import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { DeliveryOrderModel } from '../models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class DeliveryOrdersRepository {
  constructor(private apiService: ApiService) {}

  public getByShipment(shipmentId: number, isShowLoader: boolean = true): Observable<DeliveryOrderModel[]> {
    return this.apiService.get<DeliveryOrderModel[]>(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}/delivery-orders`, null, {
      isShowLoader,
    });
  }

  public create(shipmentId: number, data: any): Observable<DeliveryOrderModel> {
    return this.apiService.post<DeliveryOrderModel>(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}/delivery-orders`, data);
  }

  public get(id: number): Observable<DeliveryOrderModel> {
    return this.apiService.get<DeliveryOrderModel>(`${environment.url.prefixCustoms}v2/delivery-orders/${id}`);
  }

  public update(id: number, data: Partial<DeliveryOrderModel>): Observable<DeliveryOrderModel> {
    return this.apiService.put<DeliveryOrderModel>(`${environment.url.prefixCustoms}v2/delivery-orders/${id}`, data);
  }

  public delete(id: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/delivery-orders/${id}`);
  }

  public sent(shipmentId: number): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/delivery-orders/sent`, {}, { params: { shipmentId } });
  }
}
